import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

// Pages & Layouts
import LoginPage from "../components/Login";
import AdminDashboard from "../pages/admins/AdminDashboard";
import AdminTasksPage from "../pages/admins/AdminTasksPage";
import AdminStaffPage from "../pages/admins/AdminStaffPage";
import AdminRolesPage from "../pages/admins/AdminRolesPage";
import AccessManagementRolesPage from "../pages/admins/AccessManagementRolesPage";
import AccessManagementUsersPage from "../pages/admins/AccessManagementUsersPage";
import AdminSidebarPage from "../pages/admins/AdminSidebarPage";
import AdminCategoryPage from "../pages/admins/Category";
import AdminSubCategoryPage from "../pages/admins/SubCategory";
import AdminUnitPage from "../pages/admins/AdminUnitPage";
import ProductList from "../pages/admins/inventroy/InventoryProductList";
import AllocationPage from "../pages/admins/inventroy/AllocationPage";
import AdminAssingtask from "../pages/admins/AdminAssingtask";
import ReportsList from "../pages/accounts/ReportsList";
import ReportForm from "../pages/accounts/ReportForm";
import ReportDetail from "../pages/accounts/ReportDetail";
import ManagerQueue from "../pages/accounts/ManagerQueue";
import FinanceQueue from "../pages/accounts/FinanceQueue";
import InvoiceGenerated from "../pages/accounts/InvoiceGenerated";
import AdminCompanyPage from "../pages/admins/AdminCompanyPage";
import DepartmentManagementPage from "../pages/admins/DepartmentManagementPage";
import DesignationManagementPage from "../pages/admins/DesignationManagementPage";
import ProjectManagementPage from "../pages/admins/ProjectManagementPage";
import ProjectDetailPage from "../pages/admins/ProjectDetailPage";
import UptimeMonitoringPage from "../pages/uptime/UptimeMonitoringPage";
import ProjectTypeManagementPage from "../pages/admins/ProjectTypeManagementPage";
import TaskTypeManagementPage from "../pages/admins/TaskTypeManagementPage";
import TaskStatusManagementPage from "../pages/admins/TaskStatusManagementPage";
import TaskWorkflowManagementPage from "../pages/admins/TaskWorkflowManagementPage";
import TaskWorkflowEditor from "../pages/admins/TaskWorkflowEditor";
import TatRuleManagementPage from "../pages/admins/TatRuleManagementPage";
import FormTypeManagementPage from "../pages/admins/FormTypeManagementPage";
import FormsWorkspacePage from "../pages/forms/FormsWorkspacePage";
import FormBuilderPage from "../pages/forms/FormBuilderPage";
import FormsAssignedByMePage from "../pages/forms/FormsAssignedByMePage";
import AdminFormFillPage from "../pages/admins/AdminFormFillPage";
import FormSubmissionViewPage from "../pages/forms/FormSubmissionViewPage";
import MyFormResultsPage from "../pages/forms/MyFormResultsPage";
import FormReviewQueuePage from "../pages/forms/FormReviewQueuePage";
import FormExecutionReportsPage from "../pages/forms/FormExecutionReportsPage";
import CreateTaskPage from "../pages/tasks/CreateTaskPage";
import TaskDetailPage from "../pages/tasks/TaskDetailPage";
import MyWorkPage from "../pages/tasks/MyWorkPage";
import TaskApprovalPolicyManagementPage from "../pages/tasks/TaskApprovalPolicyManagementPage";
import MyTaskApprovalQueuePage from "../pages/tasks/MyTaskApprovalQueuePage";
import MyPerformanceDashboardPage from "../pages/dashboard/MyPerformanceDashboardPage";
import TeamPerformanceDashboardPage from "../pages/dashboard/TeamPerformanceDashboardPage";
import ProjectPerformanceDashboardPage from "../pages/dashboard/ProjectPerformanceDashboardPage";
import OrganizationDashboardPage from "../pages/dashboard/OrganizationDashboardPage";
import PerformancePeriodManagementPage from "../pages/performance/PerformancePeriodManagementPage";
import PerformanceMetricManagementPage from "../pages/performance/PerformanceMetricManagementPage";
import PerformanceProfileManagementPage from "../pages/performance/PerformanceProfileManagementPage";
import PerformanceScorecardPage from "../pages/performance/PerformanceScorecardPage";
import KraKpiConfigurationListPage from "../pages/performance/KraKpiConfigurationListPage";
import KraKpiConfigurationDetailPage from "../pages/performance/KraKpiConfigurationDetailPage";
import KpiEvidencePage from "../pages/developer/KpiEvidencePage";
import KpiEvidenceReviewPage from "../pages/admins/KpiEvidenceReviewPage";
import ReportsPage from "../pages/reports/ReportsPage";

import AdminLayout from "../components/AdminLayout";
import Layout from '../MainLayout/index';
import PrivateRoute from "./PrivateRoute";
import PermissionRoute from "./PermissionRoute";
import DynamicRoutes from "./DynamicRoutes";
import Unauthorized from '../pages/Unauthorized';
import PublicFormPage from '../pages/public/PublicFormPage';
import NewJoinerAssetRequestPage from '../pages/public/NewJoinerAssetRequestPage';

import StaffDashboard from "../pages/staffs/StaffDashboard.js";
import ProductUnitWisePage from "../pages/technicians/ProductUnitWisePage.js";
import AllocationUnitWisePage from "../pages/technicians/AllocationUnitWisePage";

import TaskManagementPage from '../pages/technicians/TaskManagementPage.js';
import TechnicianDashboard from "../pages/technicians/TechnicianDashboard.js";
import NewJoinerRequestDetailPage from "../pages/technicians/NewJoinerRequestDetailPage.jsx";
import PreventiveMaintenancePage from "../pages/technicians/PreventiveMaintenancePage.jsx";
import SoftwareLicensesPage from "../pages/softwareLicenses/SoftwareLicensesPage.jsx";
import SoftwareLicenseDetailPage from "../pages/softwareLicenses/SoftwareLicenseDetailPage.jsx";


const AppRoutes = () => {
  const { user } = useContext(AuthContext);

  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />
      {/* Phase 16 (Public Form Links): a no-login, token-secured form-fill
          page — outside PrivateRoute/AdminLayout/Layout entirely, same as
          /login. Registered before the "/*" catch-all below so a valid
          /form/f/:token URL never falls through to LoginPage. */}
      <Route path="/form/f/:token" element={<PublicFormPage />} />
      {/* Phase 52: New Joiner Asset Request -- a no-login public intake
          form (task spec §2), registered the same way as /form/f/:token:
          outside PrivateRoute/AdminLayout/Layout entirely, before the "/*"
          catch-all. */}
      <Route path="/new-joiner-asset-request" element={<NewJoinerAssetRequestPage />} />
      <Route path="/*" element={<LoginPage />} />
      {/* Admin Nested Layout */}
      <Route
        path="/admin"
        element={
          <PrivateRoute roles={["admin"]}>
            <AdminLayout />
          </PrivateRoute>
        }
      >
       
       <Route path="home" element={<AdminDashboard />} />
        <Route path="unit" element={<AdminUnitPage />} />
         <Route path="company" element={<AdminCompanyPage />} />
        <Route path="department" element={<DepartmentManagementPage />} />
        <Route path="designation" element={<DesignationManagementPage />} />
        <Route path="projects" element={<ProjectManagementPage />} />
        <Route path="projects/:projectId" element={<ProjectDetailPage />} />
        {/* Phase 44: Uptime Kuma integration, Admin/Manager dashboard --
            same shared component as /manager/uptime-monitors below, gated
            server-side by uptime_monitoring:view_all (never a role check). */}
        <Route path="uptime-monitors" element={<UptimeMonitoringPage />} />
        <Route path="project-types" element={<ProjectTypeManagementPage />} />
        <Route path="task-types" element={<TaskTypeManagementPage />} />
        <Route path="task-statuses" element={<TaskStatusManagementPage />} />
        <Route path="task-workflows" element={<TaskWorkflowManagementPage />} />
        <Route path="task-workflows/:id/editor" element={<TaskWorkflowEditor />} />
        <Route path="tat-rules" element={<TatRuleManagementPage />} />
        {/* Consolidated Forms Workspace (Build / Assign & Track / Review &
            Reports tabs) -- /admin/forms is now this workspace's root
            rather than the old plain forms-list page. form-types and the
            builder/fill/submission-view deep-link routes stay mounted as
            real pages the workspace navigates into; the other 6 former
            top-level Forms pages become redirects into the matching tab so
            old bookmarks/links keep working. */}
        <Route path="form-types" element={<FormTypeManagementPage />} />
        <Route path="forms" element={<FormsWorkspacePage />} />
        <Route path="forms/:formId/builder/:versionId" element={<FormBuilderPage />} />
        <Route path="form-assignments" element={<Navigate to="/admin/forms?tab=assign" replace />} />
        <Route path="forms-assigned-by-me" element={<Navigate to="/admin/forms?tab=assign&view=assigned-by-me" replace />} />
        <Route path="my-assigned-forms" element={<Navigate to="/admin/forms?tab=review&view=to-fill" replace />} />
        <Route path="my-assigned-forms/:assignmentUserId/fill/:submissionId" element={<AdminFormFillPage />} />
        <Route path="form-submissions/:submissionId" element={<FormSubmissionViewPage />} />
        <Route path="my-form-results" element={<Navigate to="/admin/forms?tab=review&view=results" replace />} />
        <Route path="form-review-queue" element={<Navigate to="/admin/forms?tab=review&view=to-review" replace />} />
        <Route path="form-execution-reports" element={<Navigate to="/admin/forms?tab=review&view=reports" replace />} />
        <Route path="my-performance-dashboard" element={<MyPerformanceDashboardPage />} />
        <Route path="team-performance-dashboard" element={<TeamPerformanceDashboardPage />} />
        <Route path="project-performance-dashboard" element={<ProjectPerformanceDashboardPage />} />
        <Route path="organization-dashboard" element={<OrganizationDashboardPage />} />
        <Route path="performance-periods" element={<PerformancePeriodManagementPage />} />
        <Route path="performance-metrics" element={<PerformanceMetricManagementPage />} />
        <Route path="performance-profiles" element={<PerformanceProfileManagementPage />} />
        <Route path="performance-scorecards" element={<PerformanceScorecardPage />} />
        <Route path="kra-kpi-configurations" element={<KraKpiConfigurationListPage />} />
        <Route path="kra-kpi-configurations/:configurationId" element={<KraKpiConfigurationDetailPage />} />
        {/* Phase 31: KRA/KPI Evidence & Evaluation workflow -- Admin's own
            self-service + reviewer access, separate from the portal-only
            Developer Home. */}
        <Route path="my-kpi-evidence" element={<KpiEvidencePage />} />
        <Route path="kpi-evidence-review" element={<KpiEvidenceReviewPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="my-work" element={<MyWorkPage />} />
        <Route path="task-approval-policies" element={<TaskApprovalPolicyManagementPage />} />
        <Route path="my-task-approvals" element={<MyTaskApprovalQueuePage />} />
        <Route path="tasks/create" element={<CreateTaskPage />} />
        <Route path="roles" element={<AdminRolesPage />} />
        <Route path="users" element={<AdminStaffPage />} />
        <Route path="sidebar" element={<AdminSidebarPage />} />
        <Route path="access-management/roles" element={<AccessManagementRolesPage />} />
        <Route path="access-management/users" element={<AccessManagementUsersPage />} />
        <Route path="tasks" element={<AdminTasksPage />} />
        <Route path="tasks/:taskId" element={<TaskDetailPage />} />
        <Route path="category" element={<AdminCategoryPage />} />
        <Route path="sub-category" element={<AdminSubCategoryPage />} />
        <Route path="inventory/products" element={<PermissionRoute module="products" action="view"><ProductList /></PermissionRoute>} />
        <Route path="inventory/allocation" element={<AllocationPage />} />
        <Route path="software-licences" element={<PermissionRoute module="software_licenses" action="view"><SoftwareLicensesPage /></PermissionRoute>} />
        <Route path="software-licences/:id" element={<PermissionRoute module="software_licenses" action="view"><SoftwareLicenseDetailPage /></PermissionRoute>} />
        <Route path="assign-tasks" element={<AdminAssingtask />} />
          <Route path="accounts/my-reports" element={<ReportsList />} />
          <Route path="accounts/reports/new" element={<ReportForm />} />
          <Route path="accounts/reports/:id" element={<ReportDetail />} />
          <Route path="accounts/manager" element={<ManagerQueue />} />
          <Route path="accounts/finance" element={<FinanceQueue />} />
           <Route path="accounts/invoice-generated" element={<InvoiceGenerated />} />

      </Route>

       <Route path="/technician" element={ <PrivateRoute roles={["technician"]}> <Layout /> </PrivateRoute>}>
       <Route path="home" element={<TechnicianDashboard />} />
      <Route path="new-joiner-requests/:id" element={<NewJoinerRequestDetailPage />} />
      <Route path="tasks" element={<TaskManagementPage />}/>
      <Route path="tasks/create" element={<CreateTaskPage />} />
      <Route path="my-work" element={<MyWorkPage />} />
      <Route path="task-approval-policies" element={<TaskApprovalPolicyManagementPage />} />
      <Route path="my-task-approvals" element={<MyTaskApprovalQueuePage />} />
      <Route path="products" element={<PermissionRoute module="products" action="view"><ProductUnitWisePage /></PermissionRoute>} />
      <Route path="allocations/unit-wise" element={<AllocationUnitWisePage />} />
      <Route path="preventive-maintenance" element={<PreventiveMaintenancePage />} />
      <Route path="software-licences" element={<PermissionRoute module="software_licenses" action="view"><SoftwareLicensesPage /></PermissionRoute>} />
      <Route path="software-licences/:id" element={<PermissionRoute module="software_licenses" action="view"><SoftwareLicenseDetailPage /></PermissionRoute>} />
      <Route path="inventory/products" element={<PermissionRoute module="products" action="view"><ProductList /></PermissionRoute>}/>
      {/* form-assignments / my-assigned-forms / fill: intentionally NOT
          registered here -- routes/DynamicRoutes.jsx's SHARED_ROUTES
          already mounts these (as RoleFormAssignmentsPage/
          RoleReviewFormsPage/RoleFormFillPage) for every non-Admin role,
          including technician. Registering them here too would create a
          duplicate route definition for the exact same path. */}
      <Route path="forms-assigned-by-me" element={<FormsAssignedByMePage />} />
      <Route path="form-submissions/:submissionId" element={<FormSubmissionViewPage />} />
      <Route path="my-form-results" element={<MyFormResultsPage />} />
      <Route path="form-review-queue" element={<FormReviewQueuePage />} />
      <Route path="form-execution-reports" element={<FormExecutionReportsPage />} />
      <Route path="my-performance-dashboard" element={<MyPerformanceDashboardPage />} />
      <Route path="team-performance-dashboard" element={<TeamPerformanceDashboardPage />} />
      <Route path="project-performance-dashboard" element={<ProjectPerformanceDashboardPage />} />
      <Route path="reports" element={<ReportsPage />} />
      </Route>

      <Route
  path="/manager"
  element={
    <PrivateRoute roles={["manager"]}>
      <Layout />
    </PrivateRoute>
  }
>
  <Route path="products" element={<PermissionRoute module="products" action="view"><ProductUnitWisePage /></PermissionRoute>} />
  <Route path="software-licences" element={<PermissionRoute module="software_licenses" action="view"><SoftwareLicensesPage /></PermissionRoute>} />
  <Route path="software-licences/:id" element={<PermissionRoute module="software_licenses" action="view"><SoftwareLicenseDetailPage /></PermissionRoute>} />
  {/* Phase 44: Uptime Kuma integration -- same shared component as
      /admin/uptime-monitors; gated by uptime_monitoring:view_all (see
      database/phase-44-uptime-kuma-monitoring/002_..._permissions.sql). */}
  <Route path="uptime-monitors" element={<PermissionRoute module="uptime_monitoring" action="view_all"><UptimeMonitoringPage /></PermissionRoute>} />
  <Route path="tasks/create" element={<CreateTaskPage />} />
  <Route path="my-work" element={<MyWorkPage />} />
  <Route path="task-approval-policies" element={<TaskApprovalPolicyManagementPage />} />
  <Route path="my-task-approvals" element={<MyTaskApprovalQueuePage />} />
  <Route path="inventory/products" element={<PermissionRoute module="products" action="view"><ProductList /></PermissionRoute>} />
  <Route path="allocations/unit-wise" element={<AllocationUnitWisePage />} />
  {/* form-assignments / my-assigned-forms / fill: intentionally NOT
      registered here -- see the matching comment in the /technician
      block above. routes/DynamicRoutes.jsx's SHARED_ROUTES already
      mounts these for Manager (and every other non-Admin role). */}
  <Route path="forms-assigned-by-me" element={<FormsAssignedByMePage />} />
  <Route path="form-submissions/:submissionId" element={<FormSubmissionViewPage />} />
  <Route path="my-form-results" element={<MyFormResultsPage />} />
  <Route path="form-review-queue" element={<FormReviewQueuePage />} />
  <Route path="form-execution-reports" element={<FormExecutionReportsPage />} />
  <Route path="my-performance-dashboard" element={<MyPerformanceDashboardPage />} />
  <Route path="team-performance-dashboard" element={<TeamPerformanceDashboardPage />} />
  <Route path="project-performance-dashboard" element={<ProjectPerformanceDashboardPage />} />
  <Route path="reports" element={<ReportsPage />} />
</Route>


     

     
 <Route path="/unauthorized" element={<Unauthorized />} />
      {/* ✅ Inject Dynamic Role-Based Routes as plain <Route> children */}
      {user &&
        (DynamicRoutes({ user })) // ⛳ Call it as function, not <Component />
      }
    </Routes>
  );
};

export default AppRoutes;
